
import React from 'react'
import {
    Tile
} from 'carbon-components-react';
import i18n from "../../i18n";
require("./LockedEntries.scss");

const LockedEntries = (props) => {

    return (
        <div className="task-expanded-row">
            <div className="bx--grid">
                <div className="bx--row">
                    {props.data.map((entries, index) => (
                        <Tile key={"entry" + index} className="locked-entry">
                            {
                                Object.entries(entries).map(([key, value]) => (
                                    <div id={key} className="locked-entries">
                                        <span className="title">{key}</span>: {value}
                                    </div>
                                ))
                            }
                        </Tile>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LockedEntries
